<template>
  <v-col :id="'camera_select_menu' + (index_nest + (indexCalc * index))"
         class="ma-0 pa-0 hover_menu_list" cols="auto"
         :class="{'box4': viewCount === 4, 'box9': viewCount === 9, 'box16': viewCount === 16}">
    <v-list id="camera_menu_list">
      <v-list-item v-if="!video"
                   @click="openCameraSearchDialog(index_nest + (indexCalc * index))"
                   :ripple="false">
        <v-list-item-content>
          {{tsg('changeCamera')}}
        </v-list-item-content>
      </v-list-item>
      <v-list-item v-if="video"
        @click="goVideoPlayer(index_nest + (indexCalc * index))" :ripple="false">
        <v-list-item-content>
          {{tsg('moveToCameraViewer')}}
        </v-list-item-content>
      </v-list-item>
      <v-divider v-if="video" id="middle_divider" class="ma-0 pa-0 ml-3"></v-divider>
      <v-list-item v-if="video"
        @click="deleteCamera(index_nest + (indexCalc * index))" :ripple="false">
        <v-list-item-content>
          {{tsg('deleteCamera')}}
        </v-list-item-content>
      </v-list-item>
    </v-list>
  </v-col>
</template>

<script>
import mixin from '@/mixin';
import privateSplitMixin from '../views/user-private/split-screen/mixin/privateSplitScreen'

export default {
  props: {
    group: { type: Boolean, default: false }, // 점포그룹분할화면, 지점분할화면 구분
    video: { type: Boolean, default: false }, // 해당분할화면 index에 카메라가 할당된 경우
    index_nest: Number,
    index: Number,
    indexCalc: Number,
    players: Array,
    splitScreenCameraList: Array,
    viewCount: Number,
    selectedSplitScreen: String, // 점포그룹 분할화면 속성
    currentGroupId: String, // 점포그룹 분할화면 속성
  },
  components: {

  },
  mixins: [mixin.common, privateSplitMixin],
  data: () => ({

  }),
  methods: {
    tsg(t) {
      return this.$t("lang.group." + t);
    },
    openCameraSearchDialog(index) {
      this.$emit('openCameraSearchDialog', index);
    },
    async goVideoPlayer(index) {
      this.$vloading.show();
      const idx = this.splitScreenCameraList.findIndex(r => r.index === index);
      const item = this.splitScreenCameraList[idx];

      await this.$store.commit('setStreamInfo', item);
      this.$vloading.hide();
      if(this.group) { // 점포그룹 분할화면
        this.$store.commit('setPlayerFromWhere', { from: 'splitScreen', name: this.selectedSplitScreen });
        this.pushRoute('/video-player', {
          unisCustomerCd: item.unisCustomerCd,
          customerName: item.cameraName,
          groupId: this.currentGroupId,
        })
      } else { // 지점분할화면
        this.$store.commit('setPlayerFromWhere', { from: 'privateSplitScreen', name: this.selectedSplitScreen });
        this.pushRoute('/video-player', {
          unisCustomerCd: item.unisCustomerCd,
          customerName: item.cameraName,
        })
      }
    },
    deleteCamera(index) {
      this.$emit('deleteCamera', index)
    },
  }
}
</script>

<style lang="scss" scoped>
.hover_menu_list {
  display: none;
  position: absolute;
  top: 20%;
  right: 2%;
  z-index: 3;
}
.box4 {
  width: 45%;
}
.box9 {
  width: 60%;
}
.box16 {
  width: 83%;
}
#camera_menu_list {
  border-radius: 0.3em;
  border: 1px solid #4A4A4A;
}
#middle_divider {
  background-color: #4C4C4C;
}
.v-list {
  background: #171921;
  border: 1px solid #4A4A4A;
}
::v-deep {
  .v-list-item{
    padding: 0 8px;
    min-height: 0px;
    color: white !important;
  }
  .v-list-item__content{
    color: white;
    padding: 5px 0;
  }
}
</style>